<template>
  <div class="item-container" @mouseover="showDetailBtn=true" @mouseleave="showDetailBtn=false">
  <!-- <div class="item-container"> -->
    <div class="row content">
      <div class="row content-left">
        <el-checkbox class="ckeckbox" v-model="data.checked" @change="checkedChange"></el-checkbox>
        <div @click="toDetailPage(data.id)" class="title">{{data.title}}</div>
      </div>
      <div class="row content-right">
        <el-button v-if="data.showSummary && showDetailBtn && data.text" class="show-hidden-details" @click="onShowHiddenDetails">隐藏详情</el-button>
        <el-button v-if="!data.showSummary && showDetailBtn && data.text" class="show-hidden-details" @click="onShowHiddenDetails">显示详情</el-button>
        <div>{{data.institution}}</div>
        <div class="date">{{data.date}}</div>
        <div @click="onDownload(data.link, data.title, data.institution, data.date)" class="download-img"></div>
        <div @click="onCollection" v-if="!data.collected && !showDel" class="collection-img"></div>
        <div @click="onUncollect" class="collected-img" v-if="data.collected && !showDel"></div>
        <div @click="onUncollect" v-if="showDel" class="delete1-img"></div>
      </div>
    </div>
    <div v-if="data.text">
      <div v-show="data.showSummary">
        <div class="text" v-for="(item, index) in data.text.slice(0, 3)" :key="index">
          {{item.content}}
        </div>
        <div v-if="data.text.length > 3" class="more" @click="toDetailPage(data.id)">更多匹配结果<img class="more-img" src="../../assets/img/right-arrow.svg" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
import Mark from 'mark.js';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import localStorageHelper from '@/helpers/localStorageHelper';
import { PDF_DETAIL_DATA } from '@/helpers/constants';

export default {
  data() {
    return {
      id: 0,
      showDetailBtn: false
    };
  },
  props: {
    data: {
      type: Object
    },
    showDel: {
      type: Boolean
    }
  },
  methods: {
    checkedChange() {
      this.$emit('change');
    },
    onUncollect() {
      this.$emit('uncollect', this.data.id);
    }, 
    onCollection() {
      this.$emit('collection', { id: this.data.id, text: this.data.text });
    },
    onDownload(url, title, institution, date) {
      // pdfDownloadHelper.downloadPdf(url, title);
      // this.$emit('download', this.data.id);
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit('unLogin');
      } else if (authService.getRole() === 'NOVIP') {
        eventBus.$emit('isVistor');
      } else {
        const downloadUrl = url.indexOf('?') === -1 ? url : url.replace(/\?/, '%3F');
        const fileName = title.replace(/[.|\\|/|*|?|"|<|>||]/g, '')
          .replace(/:/g, '：');
        if (downloadUrl.indexOf('.pdf') === -1) {
          message('没有找到相关资源，此PDF暂时无法下载', '错误提示', {
            confirmButtonText: '确定'
          });
        } else {
          this.$message({
            message: '正在下载...',
            duration: 2000,
            center: true
          });
          QuestionQuery.getPdfDownload(downloadUrl, fileName, institution, date).then(() => {
            
          },
          (err) => {
            if (err.status === 403) {
              this.$emit('noDownloadPermissions');
            }
          });
        }
      }
    },
    onShowHiddenDetails() {
      this.$emit('changeDetailStatus', this.data.id);
    },
    toDetailPage(id) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit('unLogin');
      } else {
        this.id = id;
        eventBus.$emit('toPdfDetail');
        localStorageHelper.setItem(PDF_DETAIL_DATA, JSON.stringify(this.data));
        const routeUrl = this.$router.resolve('/pdf-detail');
        window.open(routeUrl.href, '_blank');
      }
    }
  },
  mounted() {
    if (this.$router.currentRoute.path !== '/' && this.data.highlight) {
      const titleInstance = new Mark(document.querySelectorAll('.title'));
      titleInstance.mark(this.data.highlight.title || [], {
        element: 'span',
        className: 'highlight'
      });
      const textInstance = new Mark(document.querySelectorAll('.text'));
      textInstance.mark(this.data.highlight.text || [], {
        element: 'span',
        className: 'highlight'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  padding: 16px 0;
  box-shadow: inset 0px -1px 0px 0px#f2f3f7;
  &:hover {
    background:rgba(250,250,252,1);
  } 
  .content {
    // margin-bottom: 8px;
    justify-content: space-between;
    font-weight: 500;
    .content-left {
      .ckeckbox {
        margin-top: 2px;
      }
      .title {
        width: 400px;
        margin-left: 6px;
        line-height: 24px;
        word-wrap: break-word;
        color: #171f46;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #0055ff;
          text-decoration: underline;
        }
      }
    }
    .content-right {
      height: 24px;
      line-height: 24px;
      color: #747990;
      font-size: 12px;
      .date {
        margin-left: 16px;
      }
      .download-img {
        margin:3px 16px 0;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background: url("../../assets/img/download.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover {
          background: url("../../assets/img/download-hover.svg") no-repeat;
        }
      }
      .collection-img {
        margin-top: 3px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background: url("../../assets/img/collection.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover {
          background: url("../../assets/img/collection-hover.svg") no-repeat;
        }
      }
      .collected-img {
        margin-top: 3px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background: url("../../assets/img/collected.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
      }
      .delete1-img {
        margin-top: 3px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background: url("../../assets/img/delete1.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover {
          background: url("../../assets/img/delete1-hover.svg") no-repeat;
        }
      }
      .show-hidden-details {
        height: 24px;
        width: 72px;
        padding: 0;
        margin-right: 16px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(23, 31, 70, 1);
        border-radius: 2px;
        border: 1px solid rgba(229, 230, 238, 1);
        &:hover {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:focus {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #ffffff;
        }
        &:active {
          border: 1px solid #171f46;
          color: #171f46;
          background-color: #f2f3f7;
        }
      }
    }
  }
  .text {
    padding-left: 21px;
    padding-top: 8px;
    line-height: 22px;
    color: #747990;
    font-size: 14px;
  }
  .more {
    padding-left: 21px;
    padding-top: 8px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(116, 121, 144, 1);
    line-height: 16px;
    vertical-align: middle;
    cursor: pointer;
    .more-img {
      vertical-align: middle;
    }
  }
}
/deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #2b76ff;
  border-color: #2b76ff;
}
</style>
